import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    options: { type: Object, default: {} }
  };

  connect() {
    this.element.scrollIntoView(this.optionsValue);
  }
}
